define(["marionette", "messaging/messenger", "./template/refreshTokensTemplate.html"], function (
  Marionette,
  Messenger,
  RefreshTokensTemplate,
) {
  "use strict";

  return {
    layout: Marionette.Layout.extend({
      className: "max-height",
      template: RefreshTokensTemplate,
      regions: {
        list: ".refresh-tokens-list",
      },
      triggers: {
        "click #addRefreshToken": "add:refreshToken",
      },
    }),
  };
});
